import { render, staticRenderFns } from "./SocialMenu.vue?vue&type=template&id=0f8413d0&"
import script from "./SocialMenu.vue?vue&type=script&lang=js&"
export * from "./SocialMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports